import { SvgConsumer } from '@components/icons/svgConsumer';
import { Button } from '@components/ui/button';
import { useTranslation } from 'react-i18next';
import { ExternalScheduleActionsProps } from './types';
import { cn } from '@utils/cn';
import { RemoveScheduleDialog } from '../../remove';
import { useState } from 'react';
import { AppTooltip } from '@components/ui/tooltip/tooltip';
import { useExternalScheduleActions } from './useActions';

export const ExternalScheduleActions = (props: ExternalScheduleActionsProps) => {
  const { setOpen, completed, taskId: id, finalYards, readOnly, unsavedChanges } = props;
  const { t } = useTranslation('app');
  const [remove, setRemove] = useState(false);
  const {
    toggleDone,
    removeSchedule,
    canMarkDone,
    markDoneDisabled,
    canRemove,
    removeDisabled,
    saveDisabled,
  } = useExternalScheduleActions(props);

  const markAsDoneButton = (
    <Button
      variant={completed ? 'successSecondary' : 'secondary'}
      disabled={markDoneDisabled}
      className={cn(unsavedChanges && 'pointer-events-none')}
      onClick={toggleDone}>
      <SvgConsumer id="markAsDone" className="text-xl" />
      {completed ? t('actions.done') : t('actions.markAsDone')}
    </Button>
  );

  return (
    <div
      className={cn(
        'flex items-center gap-2',
        !id || readOnly ? 'justify-end' : 'justify-between',
      )}>
      {canMarkDone &&
        (unsavedChanges ? (
          <AppTooltip side="top" context={t('schedules.unsavedMaterialChanges')}>
            <span className="cursor-not-allowed">{markAsDoneButton}</span>
          </AppTooltip>
        ) : (
          markAsDoneButton
        ))}
      <div className="flex items-center justify-end gap-2">
        <Button variant="secondary" onClick={() => setOpen(false)}>
          {t('actions.cancel')}
        </Button>
        {canRemove && (
          <Button
            disabled={removeDisabled}
            variant="dangerSecondary"
            onClick={() => setRemove(true)}>
            {t('actions.removeSchedule')}
          </Button>
        )}
        {!readOnly && (
          <Button variant="default" type="submit" disabled={saveDisabled}>
            {t(`actions.${finalYards ? 'update' : 'save'}`)}
          </Button>
        )}
      </div>
      <RemoveScheduleDialog
        open={remove}
        setOpen={setRemove}
        onConfirm={removeSchedule.mutate}
        disabled={removeSchedule.isLoading}
      />
    </div>
  );
};
